<template>
	<el-card class="quick-search" shadow="never" header="我的项目进度">
		<el-table ref="listTable" :data="list" style="width: 100%" size="medium" height="calc(100% - 56px)" class="padding-small">
			<el-table-column label="项目名称" min-width="100" show-overflow-tooltip>
				<template slot-scope="scope">
					<el-link :underline="false" @click="toProjectDetail(scope.row)">{{ scope.row.project_title }}</el-link>
				</template>
			</el-table-column>
			<el-table-column label="制号/名称/型号" min-width="140" show-overflow-tooltip>
				<template slot-scope="scope">
					<div class="">{{ scope.row.mfg_no}}</div>
					<div class="">{{ scope.row.title}}</div>
					<div class="">{{ scope.row.model}}</div>
				</template>
			</el-table-column>
			<el-table-column label="项目编号" min-width="80" show-overflow-tooltip align="center">
				<template slot-scope="scope">
					<span class="font-16 number text-bold">{{ scope.row.project_no }}</span>
				</template>
			</el-table-column>
			<el-table-column label="计划交付时间" min-width="140" show-overflow-tooltip align="center">
				<template slot-scope="scope">
					<span>{{ scope.row.plan_deliver_time | parseTime('{y}-{m}-{d}') }}</span>
				</template>
			</el-table-column>

			<el-table-column label="状态" min-width="100" align="center">
				<template slot-scope="scope">
					<div class="process-container">
						<el-progress v-if="scope.row.status == 0" type="circle" color="#e6a23c" :stroke-width="4" :width="80" :percentage="scope.row.status" :show-text="false"></el-progress>
						<el-progress v-else-if="scope.row.status < 80" type="circle" color="#409eff" :stroke-width="4" :width="80" :percentage="scope.row.status" :show-text="false"></el-progress>
						<el-progress v-else-if="scope.row.status < 100" type="circle" color="#409EFF" :stroke-width="4" :width="80" :percentage="scope.row.status" :show-text="false"></el-progress>
						<el-progress v-else-if="scope.row.status == 100" type="circle" color="#07c160" :stroke-width="4" :width="80" :percentage="scope.row.status" :show-text="false"></el-progress>
						<div class="text-box flex-center column">
							<div v-if="scope.row.status == 0">待制造</div>
							<div v-else-if="scope.row.status < 80">在制中</div>
							<div v-else-if="scope.row.status < 100">已发货</div>
							<div v-else-if="scope.row.status == 100">已验收</div>
							<div class="font-sm" style="max-width:60px">{{parseDate(scope.row.starttime)}}</div>
						</div>
					</div>
				</template>
			</el-table-column>

			<template slot="empty">
				<img class="image huger mt-lg" src="@/assets/empty.png">
				<div class="font-md mb-hg">暂无数据</div>
			</template>
		</el-table>

	</el-card>
</template>

<script>

import { getMyMfgListApi } from '@/api/pm/mfgApi'
export default {
	data () {
		return {
			loading: false,
			list: [
			]
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		async fetchData (need) {
			if (need) {
				this.loading = true
				this.list = []
			}
			let res = await getMyMfgListApi()
			this.loading = false
			if (!res.errno) {
				this.list = Object.assign([], res.data.list)
			}
		},

		toProjectDetail (row, tab) {
			let _tab = 'task'
			if (tab) _tab = tab
			this.$router.push('/pm/detail?id=' + row.projectid + '&tab=' + _tab)
		},

		parseDate (date) {
			let dur = (new Date().getTime() - new Date(date * 1000).getTime()) / 1000
			let day = parseInt(dur / (60 * 60 * 24))
			let hour = parseInt((dur) / (60 * 60))
			let min = parseInt((dur % (60 * 60)) / 60)
			let s = ''

			if (hour)
				s = s + hour + 'h'
			if (min)
				s = s + min + 'min'
			return s
		}
	}
}
</script>

<style lang="scss" scoped>
.quick-search {
	position: relative;
	width: 100%;
	height: calc(100% - 320px);
	/deep/.el-card__body {
		height: 100%;
		position: relative;
		padding-top: 0;
	}

	.process-container {
		position: relative;
		margin: auto;
		width: 80px;
		height: 80px;
		.text-box {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			text-align: center;
		}
	}
}
</style>


